import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import moment from "moment";
import { Redirect } from "react-router";
import { ToastContainer } from "react-toastify";
import FadeLoader from "react-spinners/FadeLoader";
import arrayMove from "array-move";
import { Tabs, Button, Input } from "antd";
import "antd/dist/antd.css";
import "react-toastify/dist/ReactToastify.css";

import { getRoomMarginRight, gender, isOldData } from "modules/room";
import { isAdmin } from "modules/account";
import Header from "ui/components/header";
import ConfirmDialog from "ui/components/confirmDialog";
import notificationAudio from "assets/audios/notification.mp3";
import {
  confirmDialog as confirmDialogStrings,
  noteList as noteListStrings,
} from "ui/constants/strings";
import RoomList from "./roomList";
import NotificationList from "./notificationList";
import NoteList from "./noteList";
import SettingDialog from "./settingDialog";
import RoomDetailDialog from "./roomDetailDialog";

const { TextArea } = Input;
const { TabPane } = Tabs;

const roomSize = {
  width: 140,
  height: 150,
};

const initialRoomEditState = {
  roomEditVisible: false,
  roomEditGender: gender.male,
  roomEditPatient: "",
  roomEditID: "",
  roomEditObject: "",
  isOldData: false,
};

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // for note
      textInput: "",
      deleteNoteID: "",

      // for future redirect
      redirect: false,
      redirectID: null,

      // for onclick dialog
      roomEditVisible: false,
      roomEditGender: gender.male,
      roomEditPatient: "",
      roomEditID: "",
      roomEditObject: "",

      settingDialogVisible: false,
      confirmDeleteNoteDialogVisible: false,
      confirmLogoutDialogVisible: false,
      counter: 0,
    };
    this.screenMainRef = React.createRef();
  }

  componentDidMount() {
    const { getGroupList, isLoggedIn, listAllFamily } = this.props;
    if (isLoggedIn) {
      listAllFamily();
      getGroupList();
      this.fetchNewData();
    }
    this.updateDimensions();
    window.setInterval(() => {
      this.fetchNewData();
    }, 10000);
  }

  componentDidUpdate(prevProps) {
    const { isEditing, notifications } = this.props;
    if (prevProps.isEditing === false && isEditing === true) {
      setTimeout(() => {
        this.inputArea.focus();
      });
    }
    if (notifications.length > 0) {
      if (prevProps.notifications.length > 0) {
        const newNotificationTime = moment(notifications[0].createdAt);
        const oldNotificationTime = moment(
          prevProps.notifications[0].createdAt
        );
        if (newNotificationTime.isAfter(oldNotificationTime)) {
          this.playAudio();
        }
      } else {
        this.playAudio();
      }
    }
  }

  playAudio = () => {
    const audioItem = new Audio(notificationAudio);
    audioItem.play();
  };

  fetchNewData = () => {
    const {
      activeKey,
      getGroupDeviceData,
      getNoteList,
      isLoggedIn,
      getNotificationList,
    } = this.props;
    if (isLoggedIn) {
      if (activeKey) {
        getGroupDeviceData(activeKey);
        const past24Hour = new Date();
        past24Hour.setDate(past24Hour.getDate() - 1);
        const past24HourString = past24Hour.toISOString();
        getNotificationList("", past24HourString, false);
      }
      getNoteList();
    }
  };

  updateDimensions = () => {
    const { updateGroupListStore, isLoggedIn } = this.props;
    if (isLoggedIn) {
      const { clientWidth } = this.screenMainRef.current;
      const marginRight = getRoomMarginRight(clientWidth - 390, roomSize.width);
      updateGroupListStore({ marginRight });
    }
  };

  toggleDialogVisiable = (name, visible) => {
    this.setState({
      [name]: visible,
    });
  };

  onChangePatient = (event) => {
    this.setState({ roomEditPatient: event.target.value });
  };

  onChangeGender = (event) => {
    this.setState({ roomEditGender: event.target.value });
  };

  onSaveRoomEdit = () => {
    const { updateFamilyItem, activeKey } = this.props;
    const { roomEditID, roomEditGender, roomEditPatient, roomEditObject } =
      this.state;
    const updatedFamily = {
      name: roomEditObject.name,
      patient: roomEditPatient,
      gender: roomEditGender,
      groupIds: roomEditObject.groupIds,
    };
    updateFamilyItem(roomEditID, updatedFamily, activeKey);
    this.toggleDialogVisiable("roomEditVisible", false);
  };

  onCancelRoomEdit = () => {
    this.setState(initialRoomEditState, () => {
      this.toggleDialogVisiable("roomEditVisible", false);
    });
  };

  onRoomPress = (id) => {
    const { currentFamilies, families } = this.props;
    const selectedRoom = _.find(
      currentFamilies,
      (family) => family.suiteId === id
    );
    const selectedFamily = _.get(families, `[${id}]`, {});
    this.setState(
      {
        roomEditGender: selectedFamily.gender || gender.male,
        roomEditPatient: selectedFamily.patient,
        roomEditID: id,
        roomEditObject: selectedRoom,
        isOldData: isOldData(_.get(selectedRoom, "devices", [])),
      },
      () => this.toggleDialogVisiable("roomEditVisible", true)
    );
    this.setState({ redirect: true, redirectID: id });
  };

  onOpenSettingDialog = () => {
    this.props.getSettingsList();
    this.toggleDialogVisiable("settingDialogVisible", true);
  };

  onSortEndRooms = ({ oldIndex, newIndex }) => {
    const { currentFamilies, updateGroupListStore } = this.props;
    const newArray = arrayMove(currentFamilies, oldIndex, newIndex);
    updateGroupListStore({ currentFamilies: newArray });
  };

  onRemoveNotification = (id) => {
    const { setNotificationRead, removeNotificationItemSuccess } = this.props;
    removeNotificationItemSuccess(id);
    setNotificationRead(id);
  };

  onSortEndNotes = ({ oldIndex, newIndex }) => {
    this.setState(({ notes }) => ({
      notes: arrayMove(notes, oldIndex, newIndex),
    }));
  };

  onCancelNoteEdit = () => {
    const { cancelEditNoteItem } = this.props;
    this.setState({ textInput: "" });
    cancelEditNoteItem();
  };

  onSaveNote = () => {
    const { editID, updateNoteItem } = this.props;
    const { textInput } = this.state;
    updateNoteItem(editID, textInput);
  };

  onCreateNote = () => {
    const { editNoteItem } = this.props;
    this.setState(
      {
        textInput: "",
      },
      () => {
        editNoteItem();
      }
    );
  };

  onEditNote = (id) => {
    const { editNoteItem, notes } = this.props;
    const selectedNote = _.find(notes, (item) => item.id === id);
    this.setState(
      {
        textInput: selectedNote.message,
      },
      () => {
        editNoteItem(id);
      }
    );
  };

  onDeleteNote = () => {
    const { deleteNoteItem } = this.props;
    const { deleteNoteID } = this.state;
    if (deleteNoteID) {
      deleteNoteItem(deleteNoteID);
    }
  };

  handleChangeTab = (newActiveKey) => {
    const { getGroupDeviceDataOnTabChange } = this.props;
    getGroupDeviceDataOnTabChange(newActiveKey);
  };

  handleChangeInput = (event) => {
    this.setState({
      textInput: event.target.value,
    });
  };

  renderTabPane = (item) => {
    const {
      marginRight,
      // currentFamilies,
      families,
      notifications,
      tabChangeRefresh,
      currentFamiliesObj,
    } = this.props;
    const { id, name } = item;
    // console.log("renderTabPane tabChangeRefresh", currentFamiliesObj[id]);
    return (
      <TabPane tab={name} key={id}>
        {currentFamiliesObj[id] && (
          <RoomList
            items={currentFamiliesObj[id]}
            onSortEnd={this.onSortEndRooms}
            axis={"xy"}
            marginRight={marginRight}
            groupId={id}
            notifications={notifications}
            families={families}
            onRoomPress={this.onRoomPress}
            pressDelay={200}
          />
        )}
        {(!currentFamiliesObj[id] ||
          (tabChangeRefresh &&
            currentFamiliesObj[id] &&
            currentFamiliesObj[id].length == 0)) && (
          <FadeLoader loading={tabChangeRefresh} color={"#FFFFFF"} />
        )}
      </TabPane>
    );
  };

  renderTabs = () => {
    const { groups } = this.props;
    return (
      <Tabs onChange={this.handleChangeTab}>
        {groups.map((item) => this.renderTabPane(item))}
      </Tabs>
    );
  };

  renderNoteList = () => {
    const { notes } = this.props;
    return (
      <div className="wrapper">
        <div className="noteListTitle">
          <span className="titleText">{noteListStrings.title}</span>
          <Button onClick={this.onCreateNote} icon="plus"></Button>
        </div>
        <div className="noteListItemWrapper">
          <NoteList
            items={notes}
            onSortEnd={this.onSortEndNotes}
            axis={"y"}
            onEdit={this.onEditNote}
            onDelete={(id) => {
              this.setState(
                {
                  deleteNoteID: id,
                },
                () => {
                  this.toggleDialogVisiable(
                    "confirmDeleteNoteDialogVisible",
                    true
                  );
                }
              );
            }}
          />
        </div>
      </div>
    );
  };

  renderNoteInput = () => {
    const { textInput } = this.state;
    return (
      <div className="noteInputWrapper">
        <div className="noteInputTitle">
          <Button
            type="primary"
            className="saveButton"
            onClick={this.onSaveNote}
          >
            {noteListStrings.saveButton}
          </Button>
          <Button className="cancelButton" onClick={this.onCancelNoteEdit}>
            {noteListStrings.cancelButton}
          </Button>
        </div>
        <div className="noteInputAreaWrapper">
          <TextArea
            value={textInput}
            onChange={this.handleChangeInput}
            ref={(node) => (this.inputArea = node)}
          />
        </div>
      </div>
    );
  };

  render() {
    const {
      groups,
      isEditing,
      isLoggedIn,
      displayName,
      notifications,
      clearData,
      role,
      activeKey,
      families,
    } = this.props;
    const {
      // redirect, redirectID,
      roomEditVisible,
      roomEditID,
      settingDialogVisible,
      confirmDeleteNoteDialogVisible,
      confirmLogoutDialogVisible,
      isOldData,
    } = this.state;

    if (!isLoggedIn) {
      return <Redirect to={"/login"} />;
    }
    return (
      <div className="screen-home">
        <Header
          displayName={displayName}
          showAdminTool={isAdmin(role)}
          onAdminToolClick={() => {
            this.props.history.push("/adminTool");
          }}
          onSettingClick={() => {
            this.onOpenSettingDialog();
          }}
          onLogoutClick={() => {
            this.toggleDialogVisiable("confirmLogoutDialogVisible", true);
          }}
        />
        <div className="screen-main" ref={this.screenMainRef}>
          <div className="screen-main__roomList gradientColorBackground containerWithBoxShadow">
            {groups.length > 0 && this.renderTabs()}
          </div>

          <div className="screen-main__rightMenu">
            <div className="notificationList">
              <NotificationList
                notifications={notifications}
                families={families}
                onRemove={this.onRemoveNotification}
              />
            </div>
            <div className="noteList">
              <div className="noteListWrapper fullContent gradientColorBackground containerWithBoxShadow">
                {isEditing ? this.renderNoteInput() : this.renderNoteList()}
              </div>
            </div>
          </div>
        </div>

        <SettingDialog
          visible={settingDialogVisible}
          onCancel={() => {
            this.toggleDialogVisiable("settingDialogVisible", false);
          }}
        />
        <RoomDetailDialog
          visible={roomEditVisible}
          onCancel={() => this.onCancelRoomEdit()}
          roomEditID={roomEditID}
          activeKey={activeKey}
          isOldData={isOldData}
        />
        <ConfirmDialog
          visible={confirmDeleteNoteDialogVisible}
          headerText={confirmDialogStrings.confirmDeleteNote.headerText}
          bodyText={confirmDialogStrings.confirmDeleteNote.bodyText}
          onConfirm={this.onDeleteNote}
          onCancel={() => {
            this.toggleDialogVisiable("confirmDeleteNoteDialogVisible", false);
          }}
        />
        <ConfirmDialog
          visible={confirmLogoutDialogVisible}
          headerText={confirmDialogStrings.confirmLogout.headerText}
          bodyText={confirmDialogStrings.confirmLogout.bodyText}
          onConfirm={() => {
            clearData();
          }}
          onCancel={() => {
            this.toggleDialogVisiable("confirmLogoutDialogVisible", false);
          }}
        />

        <ToastContainer
          autoClose={3000}
          closeButton={false}
          draggable={false}
          hideProgressBar={true}
          style={{ textAlign: "center" }}
        />
      </div>
    );
  }
}

Home.defaultProps = {
  groups: [],
  notes: [],
  activeKey: "",
  isEditing: false,
  editID: null,
  isLoading: false,
  isLoggedIn: false,
  displayName: "",
};

Home.propTypes = {
  groups: PropTypes.array,
  notes: PropTypes.array,
  currentFamilies: PropTypes.array,
  notifications: PropTypes.array,
  families: PropTypes.object,
  activeKey: PropTypes.string,
  isEditing: PropTypes.bool,
  editID: PropTypes.string,
  isLoading: PropTypes.bool,
  tabChangeRefresh: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  displayName: PropTypes.string,

  getNoteList: PropTypes.func.isRequired,
  createNoteItem: PropTypes.func.isRequired,
  deleteNoteItem: PropTypes.func.isRequired,
  getGroupList: PropTypes.func.isRequired,
  getGroupDeviceData: PropTypes.func.isRequired,
  updateGroupListStore: PropTypes.func.isRequired,
  getGroupDeviceDataOnTabChange: PropTypes.func.isRequired,
  setNotificationRead: PropTypes.func.isRequired,
  editNoteItem: PropTypes.func.isRequired,
  cancelEditNoteItem: PropTypes.func.isRequired,
  updateNoteItem: PropTypes.func.isRequired,
  updateFamilyItem: PropTypes.func.isRequired,
  removeNotificationItemSuccess: PropTypes.func.isRequired,
  getSettingsList: PropTypes.func.isRequired,
  getNotificationList: PropTypes.func.isRequired,
};

export default Home;
